import React, { useEffect, useMemo, useState } from "react";
import "./MessageScreenBodyItem.css";
import Typography from "../Typography";
import Avatar, { RenderInitials } from "../Avatar";
// import CustomDropdown from "../CustomDropdown";
import { MenuItem } from "react-bootstrap";
import MessageRenderer from "../MessageRenderer/MessageRenderer";
import Chip from "../Chip/Chip";
import { getHumanReadableDate } from "../../../../../dialpad/service/chat.service";
import styled from "styled-components";
import { getName, getPlatform } from "../utils/generic";
import { CustomDropdown } from "modules/common/components";
import { Alert } from "modules/theme";
import APIManager from "modules/common/apiManager";
import { connect } from "react-redux";
import {
  chatSelector,
  globalStateSelector,
} from "../../../../../store/selector";
import { callAction, chatAction } from "../../../../../store/action";

const getRole = (message) => {
  if (message.from) return message.from;
  return "customer";
};

const AvatarImage = styled.div`
  background: url(${(props) =>
    props.image ? props.image : "/images/user_avtar.png"})
    center no-repeat;
  background-size: contain;
`;

const mAPI = new APIManager();

// const apiResponse = (errorCode, data) => {
//   if (errorCode === 201) {
//     let message = data && data.message ? data.message : "Successfully Done";
//     Alert.success(message);
//     // this.resetAllData();
//     // this.props.closeModal(true);
//   } else {
//     let message =
//       data && data.message ? data.message : "Something wrong happened";
//     Alert.error(message);
//   }
// };

// const onTranslate = (message) => {

//   let tData = {
//     text: message && message.content && message.content.text,
//     targetLanguage: "en",
//   };

//   mAPI.sendPostAPI(
//     "translate",
//     tData,
//     (data) => {
//       if (data) {
//         // Alert.success(`${data.message}`);
//       } else {
//         Alert.success(`Successfully Added`);
//       }
//       // this.resetAllData();
//       // this.props.update();
//       // this.props.closeModal(true);
//     },
//     (errorCode, data) => {
//       apiResponse(errorCode, data);
//     }
//   );
// };

function MessageScreenBodyItem({
  data,
  showAvatar,
  getImageLoading,
  selectedAssignedList,
  ...props
}) {
  const id = data.id;
  const message = data.message || {};
  // const sent = data.sent || {};
  const [translateData, setTranslateData] = useState(null);
  const [sent, setSent] = useState({});



  useEffect(() => {
    if (data.sent) {
      setSent(data.sent); // Set the updated sent object into the state
    }
  }, [data.sent]);

  // const [loading, setLoading] = useState(false),

  const currentTranslateData = useMemo(() => {
    if (message && id && selectedAssignedList) {
      const msg =
        props.messageList &&
        props.messageList[selectedAssignedList.identifier].find(
          (msg) => msg.id === id
        );
      return (
        (msg &&
          msg.message &&
          msg.message.content &&
          msg.message.content.translate) ||
        null
      );
    }
    return null;
  }, [props.messageList, selectedAssignedList, id, message]);

  useEffect(() => {
    if (currentTranslateData) {
      setTranslateData(currentTranslateData);
    }
  }, [currentTranslateData]);

  const apiResponse = (errorCode, data) => {
    if (errorCode === 201) {
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(message);
      // this.resetAllData();
      // this.props.closeModal(true);
    } else {
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
    }
  };

  const onTranslate = (message) => {

    let tData = {
      text: message && message.content && message.content.text,
      targetLanguage: "en",
    };

    mAPI.sendPostAPI(
      "translate",
      tData,
      (data) => {
        if (data) {
          // Alert.success(`${data.message}`);
          setTranslateData(data.data);
          props.updateTranslate(
            selectedAssignedList.identifier,
            message.id,
            data.data
          );
        } else {
          Alert.success(`Successfully Added`);
        }
        // this.resetAllData();
        // this.props.update();
        // this.props.closeModal(true);
      },
      (errorCode, data) => {
        apiResponse(errorCode, data);
      }
    );
  };
  const getConversationId = () => {
    const answer = props.chatAgentAssist.find((item) => item.key === "Answer");

    if (answer && Array.isArray(answer.value)) {
      const conversationData = answer.value.find(
        (val) => val.type === "text" && val.meta && val.meta.conversationId
      );

      return conversationData
        ? conversationData &&
        conversationData.meta &&
        conversationData.meta.conversationId
        : "";
    }

    return "";
  };

  const getSessionId = () => {
    const answer = props.chatAgentAssist.find((item) => item.key === "Answer");

    if (answer && Array.isArray(answer.value)) {
      const sessionData = answer.value.find(
        (val) => val.type === "text" && val.meta && val.meta.sessionId
      );

      return sessionData
        ? sessionData && sessionData.meta && sessionData.meta.sessionId
        : "";
    }

    return "";
  };

  const renderSuggestData = (message) => {
    props.setLoadingAgentAssit(true);
    if (message) {
      // this.setState({
      //   isLoading: true,
      // });

      let suggestion = message.trim() || "";
      suggestion = suggestion.trim();
      props.setChatAgentAssist(
        { key: "Question", value: suggestion },
        selectedAssignedList.identifier
      );
      const conversationId = getConversationId();
      const sessionId = getSessionId();
      mAPI.sendPostAPI(
        `/agent-response`,
        {
          teamId: selectedAssignedList.teamId,
          meta: {
            conversationId: conversationId || "",
            sessionId: sessionId || "",
          },
          slots: [],
          prompt: message.trim(),
        },
        (data) => {
          if (data) {
            // this.resetAllData();
            // this.state.suggestionsList = data;
            props.setChatAgentAssist(
              { key: "Answer", value: data },
              selectedAssignedList.identifier
            );
            props.setLoadingAgentAssit(false);
            // this.state.suggestionsList = data;
            // Alert.success(`${data.message}`);
          } else {
            props.setChatAgentAssist(
              {
                key: "Answer",
                value: [
                  {
                    type: "text",
                    content: "Something went wrong",
                    method: "error",
                  },
                ],
              },
              selectedAssignedList.identifier
            );
            props.setLoadingAgentAssit(false);
            // Alert.success(`Successfully Added`);
          }
          // this.setState({ isLoading: false });
        },

        (errorCode, data) => {
          props.setLoadingAgentAssit(false);
          // this.setState({ isLoading: false });
          if (errorCode === 201) {
            // Alert.success(`${data.message}`);
            let message =
              data && data.message ? data.message : "Successfully Done";
            Alert.success(`${message}`);
          } else {
            // Alert.error(`${data.message}`);
            let message =
              data && data.message ? data.message : "Something wrong happened";
            props.setChatAgentAssist(
              {
                key: "Answer",
                value: [
                  {
                    type: "text",
                    content: message,
                    method: "error",
                  },
                ],
              },
              selectedAssignedList.identifier
            );
            Alert.error(message);
          }
          // apiResponse(errorCode, data);
        }
      );
    }
  };

  if (!message || !message.type) {
    return null;
  }

  if(message && message.from === 'agent' && message.type === 'typing') {
    return null;
  }
  if (message && message.from === "system") {
    // return <div></div>;
    return (
      <div className="d-flex justify-content-center m-3" key={message.id} abc={message.id}>
        <Chip text={message && message.content && message.content.text} />
      </div>
    );
  }

  const isSent = sent && typeof sent === "object" && sent.error === false;

  return (
    <div
      className={`message-body-item__main message-body-item__${getRole(
        message
      )}`}
    >
      <div
        className="position-relative"
        style={
          !showAvatar ? { visibility: "hidden" } : { visibility: "visible" }
        }
      >
        <RenderInitials text={getName(data)} type={getPlatform(data)} />
      </div>
      <MessageRenderer
        message={message}
        sent={isSent}
        translate={translateData}
      />
      {message.type === "text" && (
        <div className="dropdown-section">
          <CustomDropdown
          // totalLength={this.state.listData.length || 0}
          >
            <MenuItem
              style={{ marginLeft: "0px" }}
              onClick={() => {
                if (message && message.content) {
                  navigator.clipboard.writeText(message.content.text);
                  Alert.success("Message copied successfully");
                } else {
                  Alert.error("Message not copy");
                }
              }}
            >
              {"Copy"}
            </MenuItem>
            <MenuItem
              style={{ marginLeft: "0px" }}
              onClick={() => {
                props.setActiveTabRight('smartAssistant');
                renderSuggestData(message.content.text)}}
            >
              {"Suggestion"}
            </MenuItem>
            <MenuItem
              style={{ marginLeft: "0px" }}
              onClick={() => onTranslate(message)}
            >
              {"Translate"}
            </MenuItem>
          </CustomDropdown>
        </div>
      )}
    </div>
  );
}

const stateToProps = (state) => ({
  messageList: chatSelector.getChatDynamic(state, "messageList"),
  // agentAssist: globalStateSelector.getAgentAssist(state),/
  chatAgentAssist: chatSelector.getChatAgentAssist(state),
});

const dispatchToProps = (dispatch) => ({
  setChatAgentAssist: (data, identifier) => {
    dispatch(chatAction.setChatAgentAssist(data, identifier));
  },

  updateTranslate: (selectedChat, id, translatedText) => {
    dispatch(chatAction.updateTranslate(selectedChat, id, translatedText));
  },

  setActiveTabRight: (data) => {
    dispatch(chatAction.setActiveTabRight(data));
  },

  setLoadingAgentAssit: (data) => {
    dispatch(chatAction.setLoadingAgentAssist(data));
  },
});

export default connect(stateToProps, dispatchToProps)(MessageScreenBodyItem);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/MessageScreenBodyItem/MessageScreenBodyItem.js